/* Custom Slideshow.
   Delegated init over [data-cs-root], so one copy drives every instance and
   theme-editor reloads re-init only what changed. */
(function () {
  'use strict';
  if (window.__cslideInit) return;
  window.__cslideInit = true;

  var RING = 2 * Math.PI * 8;                       /* r=8, matches the SVG */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqDesktop = window.matchMedia('(min-width: 750px)');

  function init(root) {
    if (root.dataset.csReady) return;
    root.dataset.csReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cs-slide]'));
    if (!slides.length) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cs-dot]'));
    var viewport = root.querySelector('[data-cs-viewport]');
    var count = slides.length;
    var isRTL = getComputedStyle(root).direction === 'rtl';

    var cfg = {
      autoplay: root.dataset.autoplay === 'true' && !reduce && count > 1,
      speed:    Math.max(parseInt(root.dataset.speed, 10) || 6000, 1500),
      fade:     reduce ? 0 : Math.max(parseInt(root.dataset.fade, 10) || 600, 0),
      drag:     root.dataset.drag || 'resume',
      resume:   Math.max(parseInt(root.dataset.resume, 10) || 8000, 1000),
      pause:    root.dataset.pause || 'hover'
    };

    var current = 0, acc = 0, lastTs = 0, raf = null, running = false;
    var stopped = false, resumeT = null;
    var pausedHover = false, pausedHold = false;
    var inView = true, tabOn = !document.hidden;

    /* ── Video ──────────────────────────────────────────────────────────────
       responsive-media hands each holder data-d / data-m and theme.js mounts
       every one of them the moment it intersects. The slides are stacked, so
       they all intersect together — a multi-video slideshow would download
       every file at once. Park the URLs so theme.js finds nothing to mount
       (it reads the attributes at intersection time, not at collect time, so
       this works regardless of which script ran first), then restore them one
       slide at a time. */
    slides.forEach(function (slide) {
      var h = slide.querySelector('[data-rm-video]');
      if (!h) return;
      if (h.hasAttribute('data-d')) { h.setAttribute('data-cs-d', h.getAttribute('data-d')); h.removeAttribute('data-d'); }
      if (h.hasAttribute('data-m')) { h.setAttribute('data-cs-m', h.getAttribute('data-m')); h.removeAttribute('data-m'); }
    });

    /* Same source rules theme.js uses: desktop file on desktop; on phones only
       an explicit mobile file, or the desktop one when the merchant opted in.
       Otherwise return nothing and the poster image simply stays. */
    function videoSrc(h) {
      var d = h.getAttribute('data-cs-d'), m = h.getAttribute('data-cs-m');
      if (mqDesktop.matches) return d || m;
      if (m && m !== d) return m;
      return h.getAttribute('data-mobile-fallback') === '1' ? (m || d) : '';
    }

    function mountVideo(i) {
      var slide = slides[i];
      if (!slide) return;
      var h = slide.querySelector('[data-rm-video]');
      if (!h) return;
      var existing = h.querySelector('video');
      if (existing) { var r = existing.play(); if (r && r.catch) r.catch(function () {}); return; }
      var url = videoSrc(h);
      if (!url) return;                              /* keep the poster image */
      var v = document.createElement('video');
      v.className = 'rmedia-video';
      v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
      v.preload = 'metadata';
      v.setAttribute('aria-hidden', 'true');
      v.src = url;
      /* .rmedia-video is opacity:0 until .is-playing (critical.css:118-119) —
         this is what keeps the poster visible until the video can actually
         paint, and forever if it never can. */
      v.addEventListener('canplay', function () { v.classList.add('is-playing'); });
      h.appendChild(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function pauseVideo(i) {
      var slide = slides[i];
      if (!slide) return;
      var v = slide.querySelector('video');
      if (v && !v.paused) v.pause();
    }

    /* Decode the NEXT slide only. Decoding every slide up front forces all of
       them to download and defeats loading="lazy" — on an 8-slide banner that
       is the heaviest thing on the page. */
    function decode(i) {
      var slide = slides[((i % count) + count) % count];
      var img = slide && slide.querySelector('img');
      if (img && typeof img.decode === 'function') img.decode().catch(function () {});
    }

    function ring(i, p) {
      var d = dots[i]; if (!d) return;
      var bar = d.querySelector('.cslide-ring-bar'); if (!bar) return;
      bar.style.strokeDashoffset = RING * (1 - Math.max(0, Math.min(1, p)));
    }

    function markDot(i, on) {
      var d = dots[i]; if (!d) return;
      d.classList.toggle('is-current', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
    }

    dots.forEach(function (d) {
      var bar = d.querySelector('.cslide-ring-bar');
      if (bar) { bar.style.strokeDasharray = RING; bar.style.strokeDashoffset = RING; }
    });

    function go(i) {
      var t = ((i % count) + count) % count;
      if (t === current) { acc = 0; ring(current, 0); return; }

      var out = slides[current], inc = slides[t];
      inc.classList.remove('is-peek');
      inc.style.opacity = '';
      inc.style.transition = '';
      inc.classList.add('is-current');
      out.classList.remove('is-current');
      out.classList.add('is-leaving');
      clearTimeout(out._csLeave);
      out._csLeave = setTimeout(function () { out.classList.remove('is-leaving'); }, cfg.fade + 60);

      markDot(current, false); ring(current, 0);
      pauseVideo(current);
      current = t;
      markDot(current, true);
      acc = 0; ring(current, 0);
      mountVideo(current);
      decode(current + 1);
    }

    function frame(ts) {
      if (!running) return;
      if (lastTs && !pausedHover && !pausedHold) acc += ts - lastTs;
      lastTs = ts;
      var p = acc / cfg.speed;
      if (p >= 1) { acc = 0; go(current + 1); p = 0; }
      ring(current, p);
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (running || !cfg.autoplay || stopped || !inView || !tabOn) return;
      running = true; lastTs = 0;
      raf = requestAnimationFrame(frame);
    }

    /* Cancel the rAF outright rather than just freezing the accumulator — a
       loop that keeps ticking to redraw a ring nobody can see is pure battery. */
    function stop() {
      running = false;
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    }

    function interrupt() {
      if (!cfg.autoplay) return;
      clearTimeout(resumeT);
      if (cfg.drag === 'stop') { stopped = true; stop(); return; }
      if (cfg.drag === 'off')  { acc = 0; ring(current, 0); return; }
      stop();
      resumeT = setTimeout(function () {
        if (stopped) return;
        go(current + 1);
        start();
      }, cfg.resume);
    }

    function manual(fn) {
      return function (e) { if (e) e.preventDefault(); fn(); interrupt(); };
    }

    var prevBtn = root.querySelector('[data-cs-prev]');
    var nextBtn = root.querySelector('[data-cs-next]');
    if (prevBtn) prevBtn.addEventListener('click', manual(function () { go(isRTL ? current + 1 : current - 1); }));
    if (nextBtn) nextBtn.addEventListener('click', manual(function () { go(isRTL ? current - 1 : current + 1); }));
    dots.forEach(function (d, i) { d.addEventListener('click', manual(function () { go(i); })); });

    /* Hover-pause only where a real pointer exists. On touch, a tap fires a
       synthetic mouseenter with no matching mouseleave, which freezes autoplay
       permanently after the first tap. */
    if (cfg.pause === 'hover' && window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', function () { pausedHover = true; });
      root.addEventListener('mouseleave', function () { pausedHover = false; });
    }

    /* ── Drag / swipe ───────────────────────────────────────────────────────
       Dissolve preview, not a slide: the next image fades in ON TOP as you drag
       while the current one stays fully opaque beneath, so it matches autoplay. */
    if (cfg.drag !== 'off' && count > 1) {
      var startX = 0, dragging = false, moved = false, peek = -1, ptr = null, captured = false;

      function targetFor(delta) {
        var fwd = delta < 0;
        if (isRTL) fwd = !fwd;
        return ((fwd ? current + 1 : current - 1) % count + count) % count;
      }
      function clearPeek() {
        if (peek < 0) return;
        var el = slides[peek];
        el.classList.remove('is-peek');
        el.style.opacity = ''; el.style.transition = '';
        peek = -1;
      }

      viewport.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        dragging = true; moved = false; captured = false;
        startX = e.clientX; ptr = e.pointerId;
        pausedHold = true;
        /* Not captured yet — capturing on a plain tap swallows the click and
           the slide link never navigates. Capture only once it is a real drag. */
      });

      viewport.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var delta = e.clientX - startX;
        if (!moved && Math.abs(delta) > 6) {
          moved = true;
          if (!captured) { captured = true; try { viewport.setPointerCapture(ptr); } catch (err) {} }
        }
        if (!moved || reduce) return;
        var t = targetFor(delta);
        if (t !== peek) { clearPeek(); peek = t; }
        var el = slides[t];
        el.classList.add('is-peek');
        el.style.opacity = Math.min(Math.abs(delta) / ((viewport.clientWidth || 1) * 0.6), 1);
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        pausedHold = false;
        if (captured) { try { viewport.releasePointerCapture(e.pointerId); } catch (err) {} captured = false; }
        ptr = null;

        var delta = e.clientX - startX;
        var w = viewport.clientWidth || 1;
        var commit = moved && Math.abs(delta) >= 40 && (Math.abs(delta) / w) >= 0.12;

        if (commit && peek >= 0) {
          var t = peek;
          clearPeek();
          go(t);
          interrupt();
        } else if (peek >= 0) {
          var back = slides[peek], idx = peek;
          back.style.transition = 'opacity 200ms cubic-bezier(.4,0,.2,1)';
          back.style.opacity = '0';
          peek = -1;
          setTimeout(function () {
            back.classList.remove('is-peek');
            back.style.opacity = ''; back.style.transition = '';
          }, 220);
        }
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      /* Capture phase: kill the click that follows a drag before it reaches the
         slide link, so swiping never navigates. */
      viewport.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    document.addEventListener('visibilitychange', function () {
      tabOn = !document.hidden;
      if (tabOn) start(); else { stop(); pauseVideo(current); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inView = en.isIntersecting;
          if (inView) { start(); mountVideo(current); }
          else { stop(); pauseVideo(current); }
        });
      }, { threshold: 0.01 }).observe(root);
    } else {
      mountVideo(0);
    }

    /* Prepare slide 2 at idle — late enough that it never competes with the
       first slide's paint, early enough to be decoded before the first advance. */
    if (count > 1) {
      if ('requestIdleCallback' in window) requestIdleCallback(function () { decode(1); }, { timeout: 4000 });
      else setTimeout(function () { decode(1); }, 2000);
    }

    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-cs-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
